<template>
<span @click="$emit('click')" >
  <!-- <small>created by -->
  <practitioner-faces :practitioner-ids="[ownerId]" :size='18' >
    <small class='caption' >created by</small>
  </practitioner-faces>
  <space-faces :size="size"
    v-if='spaceIds && spaceIds.length > 0 && context === "SPACE"'
    :space-ids="spaceIds" >
    <span slot='prepend' class='caption' v-text='ownerTextPrefix' />
    <!-- <v-avatar slot='prepend' :size='16' >
      <v-icon small >share</v-icon>
    </v-avatar> -->
  </space-faces>
  <!-- <practitioner-faces v-else :practitioner-ids="[ownerId]" :size='18' >
    <small class='caption' v-text='ownerTextPrefix' />
  </practitioner-faces> -->
  <br v-if='vertical' />
  <space-faces :size="size"
    v-if='spaceIds && spaceIds.length > 0 && context === "PRACTITIONER"'
    :space-ids="spaceIds" >
    <span slot='prepend' class='caption' v-text='sharingTextPrefix' />
    <!-- <v-avatar slot='prepend' :size='16' >
      <v-icon small >share</v-icon>
    </v-avatar> -->
  </space-faces>
  <v-chip label
    v-if='!spaceIds || spaceIds.length === 0'
    color="amber"
    class='v-chip--x-small' >Private</v-chip>
</span>
</template>
<script>
import SpaceFaces from '@/components/lists/SpaceFaces.vue'
import PractitionerFaces from '@/components/lists/PractitionerFaces.vue'
export default {
  name: 'SharingInformation',
  components: {SpaceFaces, PractitionerFaces},
  props: {
    context: { type: String, default: 'PRACTITIONER' }, // or space
    ownerId: { required: true },
    spaceIds: { type: Array, default: () => { return [] } },
    practitionerIds: { type: Array, default: () => { return [] } }, // explicit sharing with a person - not currently supported
    ownerTextPrefix: { type: String, default: 'owned by' },
    sharingTextPrefix: { type: String, default: 'shared with' },
    size: { type: Number, default: 16 },
    vertical: { type: Boolean, default: false }
  }
}
</script>



// WEBPACK FOOTER //
// SharingInformation.vue?18ccbeca